import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export const FlashSaleTimer = ({ endTime }) => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(endTime) - new Date();
      
      if (difference > 0) {
        return {
          hours: Math.floor(difference / (1000 * 60 * 60)),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }
      return { hours: 0, minutes: 0, seconds: 0 };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, [endTime]);

  const pad = (num) => String(num).padStart(2, '0');

  return (
    <div className="flex items-center gap-3 backdrop-blur-xl rounded-full px-6 py-3" style={{ background: 'rgba(212, 175, 55, 0.1)', border: '1px solid rgba(212, 175, 55, 0.3)' }} data-testid="flash-sale-timer">
      <Clock className="w-5 h-5" style={{ color: '#D4AF37' }} />
      <div className="flex gap-1 font-mono font-bold" style={{ color: '#D4AF37' }}>
        <span className="px-2 py-1 rounded" style={{ background: 'rgba(212, 175, 55, 0.2)' }}>{pad(timeLeft.hours)}</span>
        <span>:</span>
        <span className="px-2 py-1 rounded" style={{ background: 'rgba(212, 175, 55, 0.2)' }}>{pad(timeLeft.minutes)}</span>
        <span>:</span>
        <span className="px-2 py-1 rounded animate-pulse" style={{ background: 'rgba(212, 175, 55, 0.2)' }}>{pad(timeLeft.seconds)}</span>
      </div>
    </div>
  );
};